import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Box } from '@mui/system';
import ButtonComponent from '../ButtonComponent';
import MediumTypography from '../MediumTypography';

type OverBViewModalPropsType = {
  open: boolean;
  title: string;
  description: string;
  features: string[];
  noteLabel: string;
  noteText: string;
  onOk: () => void;
};

const OverviewModal = ({
  open,
  title,
  description,
  features,
  noteLabel,
  noteText,
  onOk,
}: OverBViewModalPropsType) => {
  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="sm"
      sx={{
        height: '70%',
        justifyContent: 'center',
        alignSelf: 'center',
        display: 'flex',
      }}
    >
      <DialogTitle sx={{ padding: '16px 16px 6px 16px' }}>
        <MediumTypography
          label={title}
          fontSize="24px"
          fontweight={700}
          textColor="#2A4241"
        />
      </DialogTitle>

      <DialogContent sx={{ padding: '16px', marginTop: '16px' }}>
        <MediumTypography
          label={description}
          textColor="#5A6A69" // softer gray
          fontSize="15px"
          fontweight={400}
          sxProps={{
            marginBottom: '12px',
            lineHeight: '1.5',
          }}
        />

        <ul style={{ margin: 0, paddingLeft: '32px', marginTop: '8px' }}>
          {features.map((feature) => (
            <li key={feature} style={{ marginBottom: '8px' }}>
              <MediumTypography
                sxProps={{
                  display: 'inline',
                  overflowWrap: 'break-word',
                }}
                label={feature}
                textColor="#2A4241"
                fontSize="16px"
                fontweight={400}
              />
            </li>
          ))}
        </ul>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <MediumTypography
            label={noteLabel}
            textColor="#2A4241"
            fontSize="15px"
            fontweight={700}
            sxProps={{
              marginTop: '12px',
              lineHeight: '1.5',
            }}
          />

          <MediumTypography
            label={noteText}
            textColor="#2A4241"
            fontSize="15px"
            fontweight={400}
            sxProps={{
              marginTop: '12px',
              marginLeft: '4px',
              lineHeight: '1.5',
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            justifyContent: 'flex-end',
            display: 'flex',
            padding: '0px 16px 16px 0px',
          }}
        >
          <ButtonComponent
            variantType="contained"
            type="submit"
            className="btn-primary btn-submit alrt_Width_btn"
            labelId="Clientpage.Okbtn"
            defaultLabelId="Ok"
            onClick={onOk}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default OverviewModal;
